import React, { useContext, useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import ItemFilter from "../../planner/component/ItemFilter";
import SummaryByDate from "../component/SummaryByDate";
import { STORAGE_BUCKET } from "../../common/constants";
import {
  arrayContainsIgnoreCase,
  equalsIgnoreCase,
  getStoreFilterStreets,
  orderMatchesStoreFilter,
} from "../../common/util";
import ItemsRollupView from "./ItemsRollupView";
import KitchenItemSwimLanes from "../../baker/screen/KitchenItemSwimLanes";
import { UserContext } from "../../context/UserContext";

export default function ItemsView(props) {
  const { user } = useContext(UserContext);
  const { data, search, fromDate, toDate, onItemProgressChange, swimLanes } = props;
  const showSwimLanes = Boolean(swimLanes);

  const [filter, setFilter] = useState("");
  const [date, setDate] = useState("");

  const [filteredResults, setFilteredResults] = useState([]);
  const storeLocations = user?.config?.storeLocation || [];
  const storeStreets = getStoreFilterStreets(user);
  const showStoreFilter = storeStreets.length > 1;

  useEffect(() => {
    if (showSwimLanes && fromDate) {
      setDate(moment(fromDate).format("YYYY-MM-DD"));
    }
  }, []);

  useEffect(() => {
    setFilteredResults([]);

    let arr = [];
    arr = data.filter((o) => {
      // check filters
      for (const [k, v] of Object.entries(filter)) {
        if (v.value) {
          if (k === "type" && !equalsIgnoreCase(o.type, v.value)) {
            return false;
          } else if (k === "fulfillment" && !equalsIgnoreCase(o.fulfillment.type, v.value)) {
            return false;
          } else if (k === "store") {
            if (!orderMatchesStoreFilter(o, v.value, storeLocations)) {
              return false;
            }
          } else if (k === "frosting" && !equalsIgnoreCase(o.variant?.frosting?.name, v.value)) {
            return false;
          } else if (k === "flavor" && !equalsIgnoreCase(o.variant?.flavor?.name, v.value)) {
            return false;
          } else if (k === "filling" && !equalsIgnoreCase(o.variant?.filling?.name, v.value)) {
            return false;
          } else if (k === "tag" && !arrayContainsIgnoreCase(o.tags, v.value)) {
            return false;
          }
        }
      }
      // passed all filters
      return true;
    });
    setFilteredResults(arr);
  }, [filter, data]);

  if (filteredResults && filteredResults.length > 0) {
    return (
      <Box>
        <Box my={2}>
          <ItemFilter
            config={[
              { name: "type", options: data.map((o) => o.type) },
              { name: "fulfillment", options: data.map((o) => o.fulfillment?.type) },
              showStoreFilter ? { name: "store", options: storeStreets } : "",
              { name: "frosting", options: data.map((o) => o.variant?.frosting?.name) },
              { name: "flavor", options: data.map((o) => o.variant?.flavor?.name) },
              { name: "filling", options: data.map((o) => o.variant?.filling?.name) },
              { name: "tag", options: data.reduce((acc, val) => acc.concat(val.tags), []) },
            ]}
            filter={filter}
            onChange={(o) => setFilter({ ...filter, ...o })}
          />
          <Box my={2} sx={{ backgroundColor: "#FFF", padding: "10px" }}>
            <SummaryByDate
              date={date}
              data={filteredResults.map((o) => {
                return {
                  date: o.fulfillment.date,
                  amount: o.total || o.price,
                  quantity: o.quantity,
                };
              })}
              from={moment(fromDate).format("YYYYMMDD")}
              to={moment(toDate).format("YYYYMMDD")}
              onChange={(value) => setDate(value !== date ? value : "")}
            />
          </Box>
        </Box>
        {showSwimLanes ? (
          <KitchenItemSwimLanes
            items={filteredResults.filter((o) => (date ? date === o.fulfillment.date : true))}
            onItemProgressChange={onItemProgressChange}
          />
        ) : (
          <ItemsRollupView
            items={filteredResults.filter((o) =>
              date && date !== o.fulfillment.date ? false : true
            )}
          />
        )}
        {/*filteredResults.map((o, idx) => {
        return (
          <Box key={idx} my={2} p={2} sx={{ backgroundColor: "#fff", display: date && date !== o.date ? "none" : "block" }}>
            {o.total ? <LineItemV2 item={o} view="min" /> : <LineItem item={o} view="min" />}
          </Box>
        );
      })*/}
      </Box>
    );
  } else {
    return (
      <Box px={2} pb={2} textAlign={"center"} sx={{ border: "1px solid #DDD" }}>
        <img style={{ width: "250px" }} src={`${STORAGE_BUCKET}/img/icon/search-results.svg`} />
        <Typography variant="subtitle1">Nothing found</Typography>
        <Typography variant="body1" color="textSecondary">
          Please change your search criteria & try again.
        </Typography>
      </Box>
    );
  }
}
